// Wishlist functionality
(function() {
  'use strict';
  
  // Initialize wishlist from localStorage
  function getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist') || '[]');
  }
  
  function saveWishlist(wishlist) {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    updateWishlistCount();
  }
  
  function addToWishlist(productHandle) {
    let wishlist = getWishlist();
    if (!wishlist.includes(productHandle)) {
      wishlist.push(productHandle);
      saveWishlist(wishlist);
      return true;
    }
    return false;
  }
  
  function removeFromWishlist(productHandle) {
    let wishlist = getWishlist();
    wishlist = wishlist.filter(handle => handle !== productHandle);
    saveWishlist(wishlist);
  }
  
  function isInWishlist(productHandle) {
    return getWishlist().includes(productHandle);
  }
  
  function updateWishlistCount() {
    const count = getWishlist().length;
    const countElements = document.querySelectorAll('.wishlist-count');
    countElements.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline' : 'none';
    });
  }
  
  // Initialize wishlist buttons on page load
  function initWishlistButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const productHandle = button.dataset.productHandle;
      
      // Set initial state
      if (isInWishlist(productHandle)) {
        button.classList.add('is-active');
        button.setAttribute('aria-label', 'Remove from wishlist');
      }
      
      // Add click event
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const handle = this.dataset.productHandle;
        
        if (isInWishlist(handle)) {
          removeFromWishlist(handle);
          this.classList.remove('is-active');
          this.setAttribute('aria-label', 'Add to wishlist');
          showNotification('Removed from wishlist');
        } else {
          addToWishlist(handle);
          this.classList.add('is-active');
          this.setAttribute('aria-label', 'Remove from wishlist');
          showNotification('Added to wishlist');
        }
      });
    });
    
    updateWishlistCount();
  }
  
  function showNotification(message) {
    // Simple notification
    const notification = document.createElement('div');
    notification.className = 'wishlist-notification';
    notification.textContent = message;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.add('show');
    }, 10);
    
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    }, 2000);
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistButtons);
  } else {
    initWishlistButtons();
  }
  
  // Re-initialize when new content is loaded (for dynamic content)
  document.addEventListener('product:loaded', initWishlistButtons);
  
})();
